var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('GGGroup', {
    attrs: {
      "prop": _vm.data.template.prop,
      "data": _vm.data.dataSource.data
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function () {
        return [_c('MPRowSlider', {
          staticClass: "gg-story-bar-wrapper",
          attrs: {
            "list": _vm.data.dataSource.data.story || [],
            "center-slides": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref) {
              var _el$preview, _el$preview2, _el$preview3;

              var el = _ref.el,
                  index = _ref.index;
              return [_c('div', {
                key: index,
                staticClass: "gg-story-bar",
                on: {
                  "click": function ($event) {
                    return _vm.onStoryClick(index);
                  }
                }
              }, [_c('div', {
                staticClass: "gg-story-bar__img-wrap"
              }, [_c('img', {
                staticClass: "gg-story-bar__img",
                attrs: {
                  "src": (_el$preview = el.preview) === null || _el$preview === void 0 ? void 0 : _el$preview.x1,
                  "srcset": ((_el$preview2 = el.preview) === null || _el$preview2 === void 0 ? void 0 : _el$preview2.x2) && (((_el$preview3 = el.preview) === null || _el$preview3 === void 0 ? void 0 : _el$preview3.x2) + " 2x"),
                  "alt": el.name
                }
              })]), _vm._v(" "), _c('span', {
                staticClass: "gg-story-bar__name"
              }, [_vm._v(" " + _vm._s(el.name) + " ")])])];
            }
          }])
        }), _vm._v(" "), _vm.preview ? _c('Teleport', {
          attrs: {
            "to": "body"
          }
        }, [_c('MPStories', {
          attrs: {
            "stories": _vm.data.dataSource.data.story,
            "active": _vm.activeStories,
            "initial-index": _vm.activeStoryIndex
          },
          on: {
            "close": _vm.closeStories
          }
        })], 1) : _c('MPStories', {
          attrs: {
            "stories": _vm.data.dataSource.data.story,
            "active": _vm.activeStories,
            "initial-index": _vm.activeStoryIndex
          },
          on: {
            "close": _vm.closeStories
          }
        })];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }